import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["document", "group", "noResults"]

  filter(event) {
    const query = this.normalize(event.currentTarget.value)
    let visibleDocuments = 0

    this.documentTargets.forEach((document) => {
      const visible = this.normalize(document.dataset.searchText).includes(query)
      document.classList.toggle("d-none", !visible)
      if (visible) visibleDocuments += 1
    })

    this.groupTargets.forEach((group) => {
      const hasVisibleDocument = group.querySelector(
        '[data-document-list-filter-target="document"]:not(.d-none)',
      )
      const visible = query.length === 0 || Boolean(hasVisibleDocument)
      group.classList.toggle("d-none", !visible)
    })

    this.noResultsTarget.classList.toggle("d-none", query.length === 0 || visibleDocuments > 0)
  }

  normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLocaleLowerCase()
  }
}
